// import { tokenBridge } from '@contexts/auth/tokenBridge';
import { fetchAuthSession } from 'aws-amplify/auth';
import { type AxiosInstance } from 'axios';

export type ResolvedBearerToken = {
  idToken?: string;
  token: string;
};

export async function resolveBearerToken(): Promise<ResolvedBearerToken | null> {
  try {
    const session = await fetchAuthSession();
    const tokens = session.tokens;

    if (tokens) {
      return {
        idToken: tokens.idToken?.toString(),
        token: tokens.accessToken.toString(),
      };
    }
  } catch (error) {
    // TODO: add sentry catching
    if (!import.meta.env.DEV) {
      console.log('Error fetching auth session:', error);
    }
  }

  // No fallback credential: every API call, including the calls/evals
  // dashboards, runs as the signed-in Cognito user.
  return null;
}

export function setTokens(httpClient: AxiosInstance): void {
  httpClient.interceptors.request.use(async _config => {
    const resolved = await resolveBearerToken();

    if (resolved) {
      _config.headers.Authorization = `Bearer ${resolved.token}`;

      if (resolved.idToken) {
        _config.headers['x-id-token'] = `Bearer ${resolved.idToken}`;
      }
    }

    return _config;
  });
}
